const winLg = 1024;

// lenis
const lenis = new Lenis({
  lerp: 0.06,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

jQuery(document).ready(function ($) {
  // in-view detect
  function inViewDetect() {
    const blocks = document.querySelectorAll(".in-view-detect, .fade-in-wrapper > *, h1,h2,h3.animated");

    [].forEach.call(blocks, ($item) => {
      function onScroll() {
        let delta = $item.getBoundingClientRect().top - window.innerHeight <= ($item.offsetHeight * -1) / 4 && !$item.classList.contains("in-view");

        if (delta) {
          setTimeout(() => {
            $item.classList.remove("in-view-detect");
            $item.classList.add("in-view");

            if ($item.tagName === "H1" || $item.tagName === "H2" || ($item.tagName === "H3" && $item.classList.contains("animated"))) {
              const text = SplitType.create($item, { types: "words, chars" });

              $item.style.visibility = "visible";

              gsap.fromTo(
                text.chars,
                {
                  scaleY: 0,
                },
                {
                  stagger: 0.015,
                  scaleY: 1,
                  ease: "cEase",
                }
              );
            }
          }, 200);
        }
      }
      onScroll();
      window.addEventListener("scroll", (e) => {
        onScroll();
      });
    });
  }
  inViewDetect();

  lenis.on("scroll", function () {
    if (lenis.actualScroll > window.innerHeight) {
      $(".calc-popup").addClass("active");
    }
  });

  //header
  var header = document.querySelector(".header");
  var topbar = document.querySelector(".topbar-wrapper");
  var offset = topbar ? topbar.clientHeight : 0;

  var headroom = new Headroom(header, { offset: offset });
  headroom.init();

  function navOpen() {
    const scrollY = $(window).scrollTop();
    $("body").css({ position: "fixed", top: -scrollY });
    $(".navbar-toggler").addClass("active");
    if ($(window).width() < winLg) {
      $(".search-toggler").addClass("active");
    }
    $(".header").addClass("nav-opened");
    $(".navigation-main").addClass("active");
    headroom.freeze();
  }

  function navClose() {
    const scrollY = document.body.style.top;
    $("body").css({ position: "initial", top: 0 });
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    $(".navbar-toggler").removeClass("active");
    if ($(window).width() < winLg) {
      $(".search-toggler").removeClass("active");
    }
    setTimeout(() => {
      $(".header").removeClass("nav-opened");
    }, 300);
    $(".navigation-main").removeClass("active");
    headroom.unfreeze();
  }

  $(".header .navbar-toggler").on("click", function () {
    if ($(this).hasClass("active")) {
      navClose();
    } else {
      navOpen();
      if ($(window).width() < winLg) {
        $(".header input[type=search]").focus();
      }
    }
  });


  // topbar
  !(function () {
    var topbar = $(".topbar-wrapper");
    if (topbar.length > 0) {
      var topbar_height = topbar.outerHeight(),
        topbarPos = 0;

      setTimeout(function () {
        gsap.to(topbar, {
          opacity: 1,
          y: topbarPos,
          duration: 0.5,
          ease: "none",
        });
        gsap.to(".header", {
          paddingTop: topbar_height,
          ease: "none",
          duration: 0.5,
          onComplete: function () {
            // inViewDetect();
          },
        });
        if (window.screen.width < 1024) {
          gsap.to(".global-wrapper", {
            paddingTop: $(".header-main").outerHeight() + topbar_height,
            duration: 0.5,
            ease: "none",
          });
        } else {
          gsap.to(".global-wrapper", {
            paddingTop: $(".header").outerHeight() + topbar_height,
            ease: "none",
            duration: 0.5,
          });
        }

        document.querySelector("body").style.setProperty("--header-top", -topbar_height + "px");
      }, 1000);

      $(window).on("resize", function () {
        var topbar_height = topbar.outerHeight();
        $(".header").css("padding-top", topbar_height);
        $(".global-wrapper").css("padding-top", $(".header").outerHeight());
        document.querySelector("body").style.setProperty("--header-top", -topbar_height + "px");
      });
    } else {
      // inViewDetect();
    }
  })();

  CustomEase.create("cEase", ".26,1,.48,1");

  // Helper function to format the numbers with leading zeros and correct decimal precision
  function formatNumber(number, digitsBeforeDecimal, digitsAfterDecimal) {
    let numString = number.toFixed(digitsAfterDecimal); // Fix the decimal part
    let [integerPart, decimalPart] = numString.split(".");

    // Add leading zeros to the integer part if necessary
    while (integerPart.length < digitsBeforeDecimal) {
      integerPart = "0" + integerPart;
    }

    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  // Card Slider
  !(function () {
    if (window.innerWidth < 768) {
      let sSlider = document.querySelector(".s-cards__slider");

      if (!sSlider) return;

      let swiperSection = new Swiper(sSlider, {
        slidesPerView: 1.23,
        loop: true,
        spaceBetween: 16,
        centeredSlides: true,
      });

      document.querySelectorAll(".counter").forEach(function (counter) {
        const targetValue = parseFloat(counter.getAttribute("data-count"));
        const targetValueString = counter.getAttribute("data-count").toString();
        const decimalIndex = targetValueString.indexOf(".");

        // Determine how many digits are before and after the decimal point
        const digitsBeforeDecimal = decimalIndex === -1 ? targetValueString.length : decimalIndex;
        const digitsAfterDecimal = decimalIndex === -1 ? 0 : targetValueString.length - decimalIndex - 1;

        // Set the initial counter text with leading zeros before it comes into view
        if (digitsBeforeDecimal <= 3) {
          counter.innerText = formatNumber(0, 2, digitsAfterDecimal); // Format as "00.00"
        } else if (digitsBeforeDecimal === 4) {
          counter.innerText = formatNumber(0, 3, digitsAfterDecimal); // Format as "000.00"
        }

        // Use IntersectionObserver to trigger counting when in view
        const observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // Stop observing after the counter starts counting
                observer.unobserve(entry.target); // Stop observing this element

                let currentCount = 0;
                const duration = 2; // Duration of the animation (in seconds)
                const startTime = performance.now();

                function animateCounter() {
                  const timeElapsed = (performance.now() - startTime) / 1000; // Time in seconds
                  if (timeElapsed < duration) {
                    // Calculate the current number to animate towards
                    currentCount = (timeElapsed / duration) * targetValue;

                    // Update the counter text
                    counter.innerText = formatNumber(currentCount, digitsBeforeDecimal, digitsAfterDecimal);
                    requestAnimationFrame(animateCounter); // Keep animating
                  } else {
                    // Ensure the final value is set after animation ends
                    counter.innerText = formatNumber(targetValue, digitsBeforeDecimal, digitsAfterDecimal);
                  }
                }

                requestAnimationFrame(animateCounter); // Start the animation
              }
            });
          },
          {
            threshold: 0.5, // Trigger when 50% of the counter is in view
          }
        );

        // Start observing the counter element
        observer.observe(counter);
      });
    } else {
      const blocks = document.querySelectorAll(".s-cards__item");

      [].forEach.call(blocks, ($item, index) => {
        function onScroll() {
          if (index === 0 && $item.getBoundingClientRect().top - window.innerHeight + $item.offsetHeight < 0) {
            // Start counting for the counter in the first section ($item)
            const counter = $item.querySelector(".counter");

            if (counter && !counter.hasAttribute("data-animated")) {
              // Mark the counter as animated so it won't run the animation again
              counter.setAttribute("data-animated", "true");

              const targetValue = parseFloat(counter.getAttribute("data-count"));
              const targetValueString = counter.getAttribute("data-count").toString();
              const decimalIndex = targetValueString.indexOf(".");

              // Determine the number of digits before and after the decimal point
              const digitsBeforeDecimal = decimalIndex === -1 ? targetValueString.length : decimalIndex;
              const digitsAfterDecimal = decimalIndex === -1 ? 0 : targetValueString.length - decimalIndex - 1;

              // Set the initial counter text with leading zeros
              counter.innerText = formatNumber(0, digitsBeforeDecimal, digitsAfterDecimal);

              let currentCount = 0;
              const duration = 2; // Duration of the animation (in seconds)
              const startTime = performance.now();

              function animateCounter() {
                const timeElapsed = (performance.now() - startTime) / 1000; // Time in seconds
                if (timeElapsed < duration) {
                  // Calculate the current number to animate towards
                  currentCount = (timeElapsed / duration) * targetValue;

                  // Update the counter text
                  counter.innerText = formatNumber(currentCount, digitsBeforeDecimal, digitsAfterDecimal);
                  requestAnimationFrame(animateCounter); // Keep animating
                } else {
                  // Ensure the final value is set after animation ends
                  counter.innerText = formatNumber(targetValue, digitsBeforeDecimal, digitsAfterDecimal);
                }
              }

              requestAnimationFrame(animateCounter); // Start the animation
            }
          }

          // Logic for the next block (for blocks[index + 1])
          if ($item.getBoundingClientRect().top - window.innerHeight + $item.offsetHeight < -68 && index < blocks.length - 1) {
            blocks[index + 1]?.classList.add("is-active");
            const nextCounter = blocks[index + 1].querySelector(".counter");

            if (nextCounter && !nextCounter.hasAttribute("data-animated")) {
              // Start animation only if this block has the 'is-active' class
              if (blocks[index + 1].classList.contains("is-active")) {
                nextCounter.setAttribute("data-animated", "true");

                const targetValue = parseFloat(nextCounter.getAttribute("data-count"));
                const targetValueString = nextCounter.getAttribute("data-count").toString();
                const decimalIndex = targetValueString.indexOf(".");

                // Determine how many digits before and after the decimal point
                const digitsBeforeDecimal = decimalIndex === -1 ? targetValueString.length : decimalIndex;
                const digitsAfterDecimal = decimalIndex === -1 ? 0 : targetValueString.length - decimalIndex - 1;

                // Set the initial counter text with leading zeros before it comes into view
                nextCounter.innerText = formatNumber(0, digitsBeforeDecimal, digitsAfterDecimal);

                let currentCount = 0;
                const duration = 2; // Duration of the animation (in seconds)
                const startTime = performance.now();

                function animateNextCounter() {
                  const timeElapsed = (performance.now() - startTime) / 1000; // Time in seconds
                  if (timeElapsed < duration) {
                    // Calculate the current number to animate towards
                    currentCount = (timeElapsed / duration) * targetValue;

                    // Update the counter text
                    nextCounter.innerText = formatNumber(currentCount, digitsBeforeDecimal, digitsAfterDecimal);
                    requestAnimationFrame(animateNextCounter); // Keep animating
                  } else {
                    // Ensure the final value is set after animation ends
                    nextCounter.innerText = formatNumber(targetValue, digitsBeforeDecimal, digitsAfterDecimal);
                  }
                }

                requestAnimationFrame(animateNextCounter); // Start the animation
              }
            }
          } else {
            blocks[index + 1]?.classList.remove("is-active");
          }
        }

        // Initial call to check visibility and start scroll logic
        onScroll();

        // Add the scroll event listener
        document.addEventListener("scroll", onScroll);
      });
    }
  })();

  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });

  if ($(".messages").length) {
    $(".messages .slide:nth-child(2n+1)").each(function () {
      $(this).addClass("even");
    });

    let slideWd = $(window).width() >= winLg ? 348 : 312;

    $(".slider").bxSlider({
      auto: true,
      pause: 6000,
      minSlides: 1,
      maxSlides: 10,
      moveSlides: 1,
      slideWidth: slideWd,
      pager: false,
      controls: false,
      slideMargin: 0,
    });
  }

  $(".calc-popup .btn-close").on("click", function () {
    $(".calc-popup").remove();
  });

  var formatPrice = wNumb({
    thousand: ",",
    prefix: "$",
    mark: ".",
    decimals: 0,
  });

  $("#unit").on("input", function () {
    let inputVal = $(this)
      .val()
      .replace(/[^0-9]/g, ""); // Remove non-numeric characters except $

    if (inputVal === "") {
      $("#return").text(formatPrice.to(0)); // Set return value to 0 when empty
      return;
    }

    let unit = parseInt(inputVal) || 0;
    let unitValue = parseInt($("#unitValue").val());
    let ret = unit * unitValue;

    $(this).val("$" + inputVal); // Ensure $ stays before the number
    $("#return").text(formatPrice.to(ret));
  });

  $("#unit").on("blur", function () {
    if ($(this).val() === "$") {
      $(this).val("$100"); // Reset to default value if left empty
      $("#return").text(formatPrice.to(100 * parseInt($("#unitValue").val())));
    }
  });
});
